<template>
  <div id="app">
    <!-- 引入全局消息提醒 -->
    <Notification v-if="showNotification" ></Notification> 

    <!-- 引入全局公告提醒,判断是否打开 -->
    <NoticeMessag v-if="showNoticetion"></NoticeMessag>
    <router-view/>
  </div>
</template>


<script>  
import Notification from './components/admin/globelNoteInfo/Notification.vue';
import NoticeMessag from './components/admin/noticeManager/noticeMessage.vue';
  
export default {  
  components: {  
    Notification,
    NoticeMessag
  },

  
  // data() {
  //   return {
  //     showNotification: false 
  //   }
  // },

  computed: {
    showNotification(){
      return this.$store.state.showNotification;
    },

    showNoticetion(){
        return this.$store.state.showNoticetion;
    } 
  }
};  
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
